import withSyntaxLayer from './factories/with-syntax-layer.mjs';
import Layer from './layer.mjs';

const SyntaxLayer = withSyntaxLayer(Layer);

export { SyntaxLayer as default };
